import { getEdgeWasteSetting } from '@/apis/paiban'
import store from '@/store'
import { isSawPaiban } from '@/util/LayoutFuncs'
import { dealHighlightMatCode } from '@/util/commonFun'
import { getPlateKnifeDiameter } from '@/util/dealPaibanData'
import { filterNestedParts } from '@/views/newPaiban/util/judgePartInOtherPart'
import { isBrandPart } from '@/views/newPaiban/util/layoutDataDeal'
import { Message } from 'element-ui'
import Vue from 'vue'

import { toDecimal } from './commonFuncs'
import {
  getEdgeLengthsFromLShape,
  sumPiercedCurveHolesAreaDedupeNested,
} from './plankCommonFuncs'

export function applyLastCutPoint(bigparts, movePlankSetting) {
  const { lastPlankCutPointEnable, lastPlankCutPoint } = movePlankSetting || {}
  if (!lastPlankCutPointEnable || !lastPlankCutPoint) return
  bigparts.forEach((bigpart) => {
    const validParts = bigpart.parts.filter(
      (p) => !p.blueAreaSurplus || p.blueAreaSurplus !== 'blueAreaSurplus'
    )
    if (!validParts.length) return
    const lastPart = validParts.reduce((max, p) =>
      +p.priority > +max.priority ? p : max
    )
    lastPart.cutOrigin = lastPlankCutPoint
  })
}

// 计算单张大板的优化率(暂时只计算矩形面积的比例)
export function calcBigpartArea(bigpart, nc_setting, isUnuseSurplus) {
  isUnuseSurplus =
    isUnuseSurplus ?? store.state.preferencesSetting.setting.isSurplusNoRoll
  let area = 0
  let areaAll = 0
  // 表示真实的面积总和！包括裁剪版！！没有条件限制
  let realAreaTotal = 0
  // 选择了余料裁剪
  let realAreaTotalSurp = 0
  // 获取存储在大板中的修边信息
  const edge = bigpart.margin ?? nc_setting.drawPlankEdgeOff ?? 0
  let plankArea = 0
  let widthEdge
  let heightEdge
  if (edge.toString().includes(',')) {
    const edgeArr = edge.split(',')
    widthEdge = Number(edgeArr[2]) + Number(edgeArr[3])
    heightEdge = Number(edgeArr[0]) + Number(edgeArr[1])
  } else {
    widthEdge = Number(edge) * 2
    heightEdge = Number(edge) * 2
  }

  for (let i = 0; i < bigpart.parts.length; ++i) {
    const arr = bigpart.parts[i].polyArr[0].map((it) => ({ x: it.X, y: it.Y }))
    if (!bigpart.parts[i].surplusPath) {
      if (bigpart.parts[i].path) {
        const arr = bigpart.parts[i].path[0].map((it) => ({
          x: Number(it.x.toFixed(2)),
          y: Number(it.y.toFixed(2)),
        }))
        plankArea += Math.abs(window.ClipperLib.Clipper.Area(arr))
      } else {
        plankArea +=
          Number(bigpart.parts[i].realRect.width.toFixed(2)) *
          Number(bigpart.parts[i].realRect.height.toFixed(2))
      }
    }
    let insideArea = 0
    bigpart.parts[i].path?.map((poly, index) => {
      if (index) {
        insideArea += Math.abs(window.ClipperLib.Clipper.Area(poly))
      }
    })
    if (bigpart.parts[i].curveHoles?.length) {
      insideArea += sumPiercedCurveHolesAreaDedupeNested(
        bigpart.parts[i].curveHoles,
        bigpart.parts[i].thick
      )
    }
    // 裁剪版标签 不纳入/纳入 利用率计算
    if (isUnuseSurplus && bigpart.parts[i].surplusPath) {
      area += 0
      realAreaTotal +=
        Math.abs(window.ClipperLib.Clipper.Area(arr)) - insideArea
    } else {
      area += Math.abs(window.ClipperLib.Clipper.Area(arr)) - insideArea
      realAreaTotal = area
    }
    if (!bigpart.parts[i].surplusPath) {
      if (bigpart.parts[i].path) {
        areaAll += Math.abs(window.ClipperLib.Clipper.Area(arr)) - insideArea
      } else {
        areaAll +=
          Number(bigpart.parts[i].realRect.width.toFixed(2)) *
            Number(bigpart.parts[i].realRect.height.toFixed(2)) -
          insideArea
      }
    }
  }
  if (bigpart.surplusInfo && Object.keys(bigpart.surplusInfo).length > 0) {
    // 玻璃切割机也是余料优化率按照矩形计算
    if (bigpart.surplusInfo.isNotSurplus || nc_setting.glass_setting) {
      bigpart.usedRate =
        area /
        ((bigpart.plankWidth - widthEdge) * (bigpart.plankHeight - heightEdge))

      bigpart.realUsedRate =
        realAreaTotal /
        ((bigpart.plankWidth - widthEdge) * (bigpart.plankHeight - heightEdge))
      // ((bigpart.surplusInfo.width - widthEdge) *
      //   (bigpart.surplusInfo.height - heightEdge))
    } else {
      bigpart.usedRate = area / (bigpart.surplusInfo.area * 1000 * 1000)
      bigpart.realUsedRate =
        realAreaTotal / (bigpart.surplusInfo.area * 1000 * 1000)
    }
  } else {
    bigpart.usedRate =
      area /
      ((bigpart.plankWidth - widthEdge) * (bigpart.plankHeight - heightEdge))

    // 将裁剪版算进去了 不受排版页裁剪版是否纳入计算的按钮限制
    bigpart.realUsedRate =
      realAreaTotal /
      ((bigpart.plankWidth - widthEdge) * (bigpart.plankHeight - heightEdge))
  }
  bigpart.usedArea = areaAll
  bigpart.realAreaTotal = realAreaTotal
  return {
    usedRate: bigpart.usedRate,
    usedArea: bigpart.usedArea,
  }
}

// 绘制完余料后, 重新设置下刀点和下刀顺序
export function calcCutPositionOrder(planks, ncSetting, userInfo) {
  if (!planks.length) return
  return new Promise((resolve) => {
    let plankWidth =
      ncSetting.drawPlankWidth ?? store.state.selectStandardPlank.plankWidth
    let plankHeight =
      ncSetting.drawPlankHeight ?? store.state.selectStandardPlank.plankHeight
    let { startPosition, xyReverse, cutDirection, surplusPosition } = ncSetting
    let rectMap = {}
    let plankMap = {}
    const stockKey = planks[0]?.stockKey
    const diameter = +getPlateKnifeDiameter(stockKey, ncSetting)
    let cutKnifeR = diameter / 2

    const realSurplusPosition = calcSurplusPositionByStartPosition(
      startPosition,
      surplusPosition,
      xyReverse
    )

    planks.forEach((bigpart) => {
      let title = `${bigpart.texture}:${bigpart.matCode}:${bigpart.thick}`
      filterNestedParts(bigpart.parts)
      for (let k = 0; k < bigpart.parts.length; ++k) {
        let part = bigpart.parts[k]
        if (part.blueAreaSurplus && part.blueAreaSurplus == 'blueAreaSurplus')
          continue
        const { startX, startY } = calcSurplusPosition(
          realSurplusPosition,
          part,
          cutKnifeR,
          { plankWidth, plankHeight }
        )

        let partRectWidth = 0
        let partRectHeight = 0
        partRectWidth = part.rect.width
        partRectHeight = part.rect.height
        let partInfo = {
          width: partRectWidth,
          height: partRectHeight,
          // startX: part.startX + cutKnifeR,
          // startY: plankHeight - partRectHeight - part.startY + cutKnifeR,
          startX: Number(startX),
          startY: Number(startY),
          isRotated: part.isRotated ? part.isRotated : false,
          partIndex: part.index,
          stockNum: part.stockNum,
          inPlankStockNum: part.inPlankStockNum,
        }
        if (part.surplusInfo) {
          partInfo.surplusInfo = part.surplusInfo
        }
        if (rectMap[title]) {
          rectMap[title].push(partInfo)
          plankMap[title].push(bigpart)
        } else {
          rectMap[title] = [partInfo]
          plankMap[title] = [bigpart]
        }
      }
    })

    const isDoorFrame =
      ncSetting.sawSetting.mentaoji_enable &&
      ncSetting.sawSetting.processType === 'doorFrame' &&
      isSawPaiban(store)
    let obj = {
      ncConfig: {
        plankWidth: plankWidth ?? ncSetting.panelSize.plankWidth,
        plankHeight: plankHeight ?? ncSetting.panelSize.plankHeight,
        startPosition: calcStartPositionBySurplus(realSurplusPosition),
        // xyReverse: xyReverse,
        cutDirection: cutDirection ?? '逆时针',
        gap: isDoorFrame ? 0 : ncSetting.panelSize.layoutGap,
        surplus_position: realSurplusPosition,
        sameWidthPlank:
          ncSetting.sawSetting.mentaoji_enable &&
          ncSetting.sawSetting.sameWidthPlank &&
          ncSetting.sawSetting.sawToLayout &&
          ncSetting.sawSetting.processType === 'weldingPlank',
        sawToLayout:
          ncSetting.sawSetting.mentaoji_enable &&
          ncSetting.sawSetting.sawToLayout &&
          ncSetting.sawSetting.processType === 'weldingPlank',
        processType: ncSetting.sawSetting.processType,
        // TODO: 焊接板才使用锯片加工
        sawCutOnlyWeld:
          ncSetting.sawSetting.sawCutOnlyWeld &&
          ncSetting.sawSetting.processType === 'weldingPlank',
        // 小板排版顺序
        sortByHeight: ncSetting.sawSetting.sortByHeight,
        new_cut_sequence: !!ncSetting.movePlankSetting?.strong_suction_zones
          .length
          ? Boolean(ncSetting.movePlankSetting?.newCutSequence)
          : false,
        strong_suction_zones: ncSetting.movePlankSetting?.strong_suction_zones,
        safe_length: ncSetting.movePlankSetting?.safe_length,
        scattered_layout: ncSetting.movePlankSetting?.scattered_layout,
      },
      layoutRectMap: rectMap,
      uid: userInfo.id,
    }
    if (sessionStorage.getItem('thinkerx_material')) {
      obj['from'] = '门窗erp'
    }

    const callBack = (res) => {
      if (res.status == 1) {
        Object.keys(res.result.data).forEach((title) => {
          let newPointArr = res.result.data[title]
          for (let i = 0; i < newPointArr.length; ++i) {
            let bigpart = plankMap[title][i]
            for (let k = 0; k < bigpart.parts.length; ++k) {
              let plank = bigpart.parts[k]
              if (plank.index === newPointArr[i].index) {
                plank.priority = newPointArr[i].priority
                plank.cutOrigin = newPointArr[i].cutOrigin
              }
            }
          }
        })
      } else {
        Message({
          type: 'error',
          message: '计算下刀点失败!',
        })
      }
      applyLastCutPoint(
        Object.values(plankMap).flat(),
        ncSetting.movePlankSetting
      )
      resolve(true)
    }

    const isWebQT = window.webToQt && window.webToQt.calcPriority
    if (isWebQT) {
      window.webToQt.calcPriorityFinished.connect(callBack)
      window.webToQt.calcPriority(obj)
    } else {
      Vue.prototype.$token('/get_cal_priority', obj, callBack)
    }
  })
}

/**
 * @param {Object} ctx 画布对象
 * @param {Number} x 中心坐标
 * @param {Number} y 中心坐标
 * @param {Number} r 圆圈半径
 *
 */

export function circleText(ctx, x, y, r, text, scale) {
  const textInfo = calcTextSize(text)
  ctx.beginPath()
  ctx.arc(x, y, r, 0, 2 * Math.PI)
  ctx.stroke()
  ctx.closePath()
  ctx.fillText(
    text,
    x - (textInfo.width * scale) / 2,
    y + (textInfo.height * scale) / 4
  )
}

function calcTextSize(text) {
  let span = document.createElement('span')
  let result = {}
  result.width = span.offsetWidth
  result.height = span.offsetHeight
  span.style.visibility = 'hidden'
  span.style.fontSize = `14px`
  span.style.fontFamily = 'PingFangSC-Regular, PingFang SC'
  span.style.display = 'inline-block'
  document.body.appendChild(span)
  if (typeof span.textContent != 'undefined') {
    span.textContent = text
  } else {
    span.innerText = text
  }
  result.width = parseFloat(window.getComputedStyle(span).width) - result.width
  result.height =
    parseFloat(window.getComputedStyle(span).height) - result.height
  document.body.removeChild(span)
  return result
}

export async function dealPlankType(paibanData, allPartDataUnique) {
  // 除五金外 采购单其他数据不统计 不下料板件
  let realPlankList = paibanData.filter(
    (item) => !item.parts.some((part) => part.isDesMaterialNoCut)
  )
  let matCodeObj = {}
  // 聚类统计
  realPlankList.forEach((data, index) => {
    const matCodeArr = data.stockKey.split(':')
    matCodeArr.pop()
    const type =
      matCodeArr.join(':') +
      (data.otherPlate
        ? `:特殊大板${data.plankHeight}*${data.plankWidth}`
        : data.surplusInfo && !data.surplusInfo.isNotSurplus
        ? `余料大板${data.plankHeight}*${data.plankWidth}${index}`
        : `:${data.plankWidth}*${data.plankHeight}`)
    if (matCodeObj[type]) {
      matCodeObj[type].push({ ...data, plankOrderIndex: index + 1 })
    } else {
      matCodeObj[type] = [{ ...data, plankOrderIndex: index + 1 }]
    }
  })
  const result = Object.keys(matCodeObj).map((key) => {
    const plankOrderNumber = matCodeObj[key]
      .map((item) => item.plankOrderIndex)
      .sort((a, b) => a - b)
      .join('.')
    const plank = JSON.parse(JSON.stringify(matCodeObj[key][0]))
    // 针对 xy 互换处理宽高
    if (store.state.ncSetting && store.state.ncSetting.xyReverse) {
      const width = plank.plankWidth
      const height = plank.plankHeight
      plank.plankWidth = height
      plank.plankHeight = width
    }
    let matCode = plank.matCode
    if (plank.parts[0] && plank.parts[0].is_high_gloss_plank) {
      matCode
    }

    const plankArr = matCodeObj[key]
    if (key.includes('余料大板') && plankArr.length > 1) {
      return plankArr.map((plankItem) => {
        const surplusInfo = plankItem.surplusInfo
        let midH, midW
        if (surplusInfo && surplusInfo.shape == 'lshape') {
          midH = surplusInfo.y4
          midW = surplusInfo.x4
          if (surplusInfo.path && surplusInfo.path.length) {
            const { secondLongestHorizontalEdge, secondLongestVerticalEdge } =
              getEdgeLengthsFromLShape(surplusInfo.path)
            midH = toDecimal(secondLongestVerticalEdge.size, 2)
            midW = toDecimal(secondLongestHorizontalEdge.size, 2)
          }
        }
        return {
          matCode: dealHighlightMatCode(matCode),
          // 这里的余料大板和特殊大板如果有自己的颜色就使用自己的颜色，没有就使用定义的颜色
          // 由于已经做过处理所以这里使用oriBigTexture，
          // 如果生效了混排那么oriBigTexture和texture不相等，oriBigTexture是大板本身的颜色，texture是定义的颜色
          // 否则oriBigTexture和texture相等，都是自身的颜色。
          texture: plankItem.oriBigTexture,
          thick: plankItem.thick,
          plankNum: plankItem.surplusInfo
            ? plankItem.surplusInfo.plankNum
            : plankItem.plankNum ?? '',
          height:
            key.includes('余料大板') && plankItem.surplusInfo?.shape == 'lshape'
              ? `${plankItem.plankHeight}(${midH})`
              : plankItem.plankHeight,
          width:
            key.includes('余料大板') && plankItem.surplusInfo?.shape == 'lshape'
              ? `${plankItem.plankWidth}(${midW})`
              : plankItem.plankWidth,
          count: matCodeObj[key].length,
          plankType: key.includes('特殊大板')
            ? 'special'
            : key.includes('余料大板')
            ? 'surplus'
            : 'normal',
          branch_name: key.includes('余料大板')
            ? plankItem.surplusInfo.branch_name == '-'
              ? '余料清单'
              : plankItem.surplusInfo.branch_name
            : '-',
          // 采购单大板序号添加
          plankOrderNumber: plankItem.plankOrderIndex,
          colorId: plankItem.colorId,
          brandName: plankItem.brandName,
          supplierName: plankItem.supplierName,
        }
      })
    } else {
      const surplusInfo = plank.surplusInfo
      let midH, midW
      if (surplusInfo && surplusInfo.shape == 'lshape') {
        midH = surplusInfo.y4
        midW = surplusInfo.x4
        if (surplusInfo.path && surplusInfo.path.length) {
          const { secondLongestHorizontalEdge, secondLongestVerticalEdge } =
            getEdgeLengthsFromLShape(surplusInfo.path)
          midH = toDecimal(secondLongestVerticalEdge.size, 2)
          midW = toDecimal(secondLongestHorizontalEdge.size, 2)
        }
      }

      return {
        matCode: dealHighlightMatCode(matCode),
        texture: plank.oriBigTexture,
        thick: plank.thick,
        plankNum: plank.surplusInfo
          ? plank.surplusInfo.plankNum
          : plank.plankNum ?? '',
        height:
          key.includes('余料大板') && plank.surplusInfo?.shape == 'lshape'
            ? `${plank.plankHeight}(${midH})`
            : plank.plankHeight,
        width:
          key.includes('余料大板') && plank.surplusInfo?.shape == 'lshape'
            ? `${plank.plankWidth}(${midW})`
            : plank.plankWidth,
        count: matCodeObj[key].length,
        plankType: key.includes('特殊大板')
          ? 'special'
          : key.includes('余料大板')
          ? 'surplus'
          : 'normal',
        branch_name: key.includes('余料大板')
          ? plank.surplusInfo.branch_name == '-'
            ? '余料清单'
            : plank.surplusInfo.branch_name
          : '-',
        // 采购单大板序号添加
        plankOrderNumber,
        colorId: plank.colorId,
        brandName: plank.brandName,
        supplierName: plank.supplierName,
      }
    }
  })

  let withoutBujianOrAwaitStorePlankData = []
  let withBujianOrAwaitStorePlankData = []

  // 统计封边信息
  /** 所有小板 */
  const parts = paibanData.map((d) => d.parts).flat(1)
  // 项目地址列表
  const addressList = []
  parts.forEach((item) => {
    if (item._isBujian || item._isAwaitStorePlank) {
      withBujianOrAwaitStorePlankData.push(item)
    } else {
      withoutBujianOrAwaitStorePlankData.push(item)
    }
    const address = item.address
    if (address && !addressList.includes(address) && !item.isDesMaterialNoCut) {
      addressList.push(address)
    }
  })

  // 骨骼门 封边计算使用原始板
  const getFrameDoorChildrenForEdge = (part) => {
    if (
      part?.frame_door &&
      Array.isArray(part?.frame_door_children) &&
      part.frame_door_children.length === 5
    ) {
      return part.frame_door_children
    }
    return null
  }

  // 如果使用的余料和特殊大板， 需要将小板的封边颜色改为大板的颜色（开启了不同颜色小板混排功能）
  const replaceTextureParts = paibanData
    .filter((item) => !item.parts.some((part) => part.isDesMaterialNoCut))
    .flatMap((bigPlank) => {
      const { oriBigTexture, texture: bigTexture, parts } = bigPlank
      return parts.flatMap((part) => {
        const edgeStatParts = getFrameDoorChildrenForEdge(part) || [part]
        return edgeStatParts.map((edgePart) => {
          const { oriTexture, texture } = edgePart
          // 两种情况： 1.没开混排； 2. 开启混排后，这种使用的小板和大板的颜色就是定义的颜色； 3. 开启混排，标准和没有颜色的特殊大板
          if (oriBigTexture === bigTexture && oriTexture === texture)
            return edgePart
          return {
            ...edgePart,
            texture: oriBigTexture,
            edge_length_info2:
              edgePart.edge_length_info2?.map((item) => {
                return {
                  ...item,
                  texture: oriBigTexture,
                }
              }) || null,
          }
        })
      })
    })

  const partsEdgInfoArrList = await calculateEdgeBandingData(
    replaceTextureParts
  )
  const allEdgInfoArrList = await calculateEdgeBandingData(allPartDataUnique)
  // 统计五金件信息
  const partsChildrenInfo = calculateHardwareData(
    withoutBujianOrAwaitStorePlankData
  )
  const partsChildrenRes = partsChildrenInfo
  const partsChildrenRes2 = calculateHardwareData(
    withBujianOrAwaitStorePlankData
  )
  const partsEdgInfoRes = partsEdgInfoArrList.flat(1)
  const allEdgInfoRes = allEdgInfoArrList.flat(1)
  return {
    plankData: result.flat(Infinity),
    edgeData: partsEdgInfoRes,
    addonData: partsChildrenRes,
    supplementAddonData: partsChildrenRes2,
    allEdgeData: allEdgInfoRes,
    addressData: addressList.filter((item) => item),
  }
}
// 统计封边数据
async function calculateEdgeBandingData(parts) {
  const wasteSettingRes = await getEdgeWasteSetting()
  let wasteRatio = 0
  let wasteRatioSide = 0
  if (wasteSettingRes.status) {
    // useWAste 按照长度来计算损耗
    // wasteRatio 损耗比例 每米损耗多少
    // useWasteSide 按照封边数来计算损耗
    // wasteRatioSide 损耗比例 每条封边损耗多少
    const {
      useWaste,
      wasteRatio: war,
      useWasteSide,
      wasteRatioSide: wars,
    } = wasteSettingRes.data
    if (useWaste) {
      wasteRatio = war
    }
    if (useWasteSide) {
      wasteRatioSide = wars * 1000 // 米转毫米
    }
  }
  // 按厚度分组
  const partGroup = Array.from(parts).reduce((res, cur) => {
    let groupKey = String(cur.thick) + ',' + cur['texture']
    if (isBrandPart(cur)) {
      groupKey += ',' + cur.brandName + ',' + cur.supplierName
    }
    if (res.hasOwnProperty(groupKey)) {
      res[groupKey].push(cur)
    } else {
      res[groupKey] = [cur]
    }
    return res
  }, {})
  const edgInfoArrList = []
  for (const key in partGroup) {
    const parts = partGroup[key]
    const info = parts.reduce((re, cur) => {
      if (cur['edge_length_info2']) {
        const edgeLengthInfo2 = cur['edge_length_info2']
        const edgeInfo = cur['edgeInfo'] ?? '←0↓0→0↑0'
        const str = edgeInfo

        // 解析封边信息，获取各边的厚度
        const leftMatch = str.match(/←([\d.]+)/)
        const bottomMatch = str.match(/↓([\d.]+)/)
        const rightMatch = str.match(/→([\d.]+)/)
        const topMatch = str.match(/↑([\d.]+)/)

        const leftThick = leftMatch ? Number(leftMatch[1]) : 0
        const bottomThick = bottomMatch ? Number(bottomMatch[1]) : 0
        const rightThick = rightMatch ? Number(rightMatch[1]) : 0
        const topThick = topMatch ? Number(topMatch[1]) : 0
        const thickArr = [leftThick, bottomThick, rightThick, topThick]

        // 获取edge_texture_map的颜色信息
        const edgeTextureMap = cur['edge_texture_map'] || {}
        const leftColor = edgeTextureMap['1'] || ''
        const bottomColor = edgeTextureMap['2'] || ''
        const rightColor = edgeTextureMap['3'] || ''
        const topColor = edgeTextureMap['4'] || ''

        // 遍历edge_length_info2数组
        edgeLengthInfo2.forEach((item) => {
          const thick = item.thick
          const len = Number(item.length)
          const texture = item.texture || ''
          // 同一厚度封边的数量
          const count = thickArr.filter((el) => el == thick).length || 1
          const fixedThick = Number(Number(thick).toFixed(2))

          // 根据封边厚度和纹理匹配对应的颜色
          let color = ''

          // 首先尝试根据厚度匹配edge_texture_map中的颜色
          if (thick == leftThick && leftThick > 0) {
            color = leftColor
          } else if (thick == bottomThick && bottomThick > 0) {
            color = bottomColor
          } else if (thick == rightThick && rightThick > 0) {
            color = rightColor
          } else if (thick == topThick && topThick > 0) {
            color = topColor
          }

          // 优先使用texture字段作为颜色，确保相同厚度的不同纹理被正确区分
          if (texture) {
            color = texture
          }

          // 使用厚度+颜色作为唯一键，避免相同厚度被合并
          const uniqueKey = `${fixedThick}_${color}`

          if (re.hasOwnProperty(uniqueKey)) {
            re[uniqueKey].leng += len
            re[uniqueKey].waste += wasteRatioSide * count
          } else {
            re[uniqueKey] = {
              leng: len,
              waste: wasteRatioSide * count,
              color: color,
            }
          }
        })
      } else if (cur['edge_length_info']) {
        const lengKeys = Object.keys(cur['edge_length_info'])
        const edgeInfo = cur['edgeInfo'] ?? '←0↓0→0↑0'
        const str = edgeInfo
        const regex = /(?:←|↓|→|↑)[^←↓→↑]+/g
        const edgeArr = str.match(regex)
        /** 获取非零封边 */
        const nonZeroEdgeArr = edgeArr
          .map((el) => Number(String(el).slice(1)))
          .filter((el) => Number(el))
        /** 统计非零封边数量 key为封边厚度 */
        const wasteCountObj = nonZeroEdgeArr.reduce((res, cur) => {
          if (res.hasOwnProperty(cur)) {
            res[cur]++
          } else {
            res[cur] = 1
          }
          return res
        }, {})
        lengKeys.forEach((lenKey) => {
          const len = Number(cur['edge_length_info'][lenKey])
          const fixedLenKey = Number(Number(lenKey).toFixed(2))
          // 使用厚度+颜色作为唯一键，edge_length_info2是拼上了颜色的这里不拼上就会出现同种厚度颜色的封边有两条或多条数据
          const uniqueKey = `${fixedLenKey}_${cur.texture}`
          if (re.hasOwnProperty(uniqueKey)) {
            re[uniqueKey].leng += len
            re[uniqueKey].waste += wasteCountObj[lenKey] * wasteRatioSide
          } else {
            re[uniqueKey] = {
              leng: len,
              waste: wasteCountObj[lenKey] * wasteRatioSide,
            }
          }
        })
      } else {
        if (cur.edgeInfo) {
          const str = cur.edgeInfo
          const regex = /(?:←|↓|→|↑)[^←↓→↑]+/g
          const edgeArr = str.match(regex)
          for (let i = 0; i < edgeArr.length; i++) {
            const el = String(edgeArr[i])
            const lenKey = Number(el.slice(1))
            let len = 0
            if (lenKey && Number(lenKey)) {
              if (el.includes('←') || el.includes('→')) {
                len += cur.oRect.height
              } else {
                len += cur.oRect.width
              }
              // 使用厚度+颜色作为唯一键，edge_length_info2是拼上了颜色的这里不拼上就会出现同种厚度颜色的封边有两条或多条数据
              const uniqueKey = `${lenKey}_${cur.texture}`
              if (re.hasOwnProperty(uniqueKey)) {
                re[uniqueKey].leng += len
                re[uniqueKey].waste += wasteRatioSide
              } else {
                re[uniqueKey] = {
                  leng: len,
                  waste: wasteRatioSide,
                }
              }
            }
          }
        }
      }
      return re
    }, {})
    const edgeInfoArr = []
    for (const thickKey in info) {
      const length = info[thickKey].leng
      const wasteLength = info[thickKey].waste
      const keyArr = key.split(',')
      const finalWaste = length * wasteRatio + wasteLength

      // 从thickKey中提取厚度（格式：thick_color）
      const thick = thickKey.includes('_') ? thickKey.split('_')[0] : thickKey

      edgeInfoArr.push({
        // 老板良要求封边的宽度和厚度对调传
        width: thick,
        thick: keyArr[0],
        length: length,
        color: info[thickKey].color || keyArr[1], // 优先使用 edge_length_info2 的 color，否则使用原来的逻辑
        waste: finalWaste,
        brand_name: keyArr[2] ?? '',
        supplier_name: keyArr[3] ?? '',
      })
    }

    edgInfoArrList.push(edgeInfoArr)
  }
  return edgInfoArrList
}
// 统计五金数据
function calculateHardwareData(parts) {
  const result = []
  parts.forEach((cur) => {
    // 如果存在hardware字段，直接取hardware中的数据
    if (cur.hardware) {
      result.push(...cur.hardware)
    } else {
      // 如果不存在hardware，则处理partsChildren和handle.partsChildren
      if (cur.partsChildren) {
        result.push(...cur.partsChildren)
      }
      if (cur.handle && cur.handle.partsChildren) {
        result.push(...cur.handle.partsChildren)
      }
    }
  })

  return result
}

// 处理长圆孔异形孔的数据
export function dealCurveHoles(curveHoles) {
  if (!curveHoles) return
  const specialCurveHoles = []
  const commonCurveHoles = []
  // 区分特殊长圆孔(牛角槽)
  curveHoles.forEach((item) => {
    if (item.knifeName) {
      specialCurveHoles.push(item)
    } else {
      commonCurveHoles.push(item)
    }
  })
  // 牛角槽只需要绘制大的那一个就行
  const maxSpecialCurveHoles = getPathsMaxAreaObj(specialCurveHoles)
  // 最终使用的长圆孔
  const finalCurveHoles = [...commonCurveHoles, ...maxSpecialCurveHoles]
  return finalCurveHoles
}
// 获取打穿异形孔
export function getThroughPathObj(obj, thick, isThrough = true) {
  if (!obj) return []
  const result = obj.filter((item) => {
    const { deep, path, shape, depth } = item
    if (!path && !shape) return false
    const val = deep ?? depth
    return isThrough ? +val + 0.0000001 >= thick : val < thick
  })
  return result
}
// 获取对象路径中面积最大的
export function getPathsMaxAreaObj(arr, field = 'path') {
  if (!arr?.length) return []
  let maxArea = -1,
    maxObj = arr[0]
  arr.forEach((it) => {
    if (!it[field]) return
    const area = Math.abs(window.ClipperLib.Clipper.Area(it[field]))
    if (area > maxArea) {
      maxArea = area
      maxObj = it
    }
  })
  return [maxObj]
}

// 根据余料摆放位置，计算排版的起始顺序（原来代码中有加减刀半径）（返回的板子的起始坐标是余料摆放位置的对角位置）
export function calcSurplusPosition(
  surplusPosition,
  part,
  cutKnifeR,
  plank,
  isReverse = false
) {
  const { startY, startX, rect } = part
  const plankHeight = Number(plank.plankHeight)
  const plankWidth = Number(plank.plankWidth)
  const width = Number(rect.width)
  const height = Number(rect.height)
  // const realCutknifeR = isReverse ? -cutKnifeR : cutKnifeR
  const realCutknifeR = 0
  switch (surplusPosition) {
    case 'bottomLeft':
      return {
        startX: plankWidth - startX - width,
        startY: startY + realCutknifeR,
      }
    case 'bottomRight':
      return {
        startX: startX + realCutknifeR,
        startY: startY + realCutknifeR,
      }
    case 'topLeft':
      return {
        startX: plankWidth - startX - width + realCutknifeR,
        startY: plankHeight - startY - height + realCutknifeR,
      }
    case 'topRight':
      return {
        startX: startX + realCutknifeR,
        startY: plankHeight - startY - height + realCutknifeR,
      }
  }
}
// 根据余料摆放位置计算出起始位置
export function calcStartPositionBySurplus(surplusPosition) {
  switch (surplusPosition) {
    case 'bottomLeft':
      return '右上角'
    case 'bottomRight':
      return '左上角'
    case 'topLeft':
      return '右下角'
    case 'topRight':
      return '左下角'
    default:
      return '左下角'
  }
}
// 根据计算位置计算出余料摆放位置
export function calcSurplusPositionByStartPosition(
  startPosition,
  surplusPosition,
  isXyReverse
) {
  // 记录四个位置的对角位置
  const reversePositionMap = new Map([
    ['topLeft', 'bottomRight'],
    ['bottomLeft', 'topRight'],
    ['topRight', 'bottomLeft'],
    ['bottomRight', 'topLeft'],
  ])
  const positionMap = new Map([
    ['右上角', 'topRight'],
    ['右下角', 'bottomRight'],
    ['左上角', 'topLeft'],
    ['左下角', 'bottomLeft'],
  ])
  // 如果未开启了xy轴互换，那么不处理
  // 2. 开启了xy轴互换，就分以下情况：
  // 2.1 如果起始位置和余料摆放位置相同/完全相反，那么就原样返回surplusPosition
  // 2.2 否则的话就返回余料位置的对角位置
  if (!isXyReverse) return surplusPosition
  // 判断起始位置和余料摆放位置是否相同或者完全相反
  if (
    positionMap.get(startPosition) === surplusPosition ||
    reversePositionMap.get(positionMap.get(startPosition)) === surplusPosition
  )
    return surplusPosition
  else return reversePositionMap.get(surplusPosition)
}

export function checkPointInRect(point, rect) {
  const { x, y } = point
  return (
    x >= rect.x &&
    x <= rect.x + rect.width &&
    y >= rect.y &&
    y <= rect.y + rect.height
  )
}

/**
 * 统计小板面积
 * @param allParts 小板列表
 * @returns 面积统计对象
 */
export function calcPartsArea(allParts) {
  const groupNoObj = allParts.reduce((res, cur) => {
    const groupId = cur.groupId
    const orderId = cur.orderId
    let type = '-'
    let groupNo = '-'
    if (groupId) {
      groupNo = groupId
      type = 'fog_id'
    } else if (orderId) {
      groupNo = orderId
      type = 'order_id'
    }
    const gropKey = groupNo + '@_@' + type
    if (Reflect.has(res, gropKey)) {
      res[gropKey].push(cur)
    } else {
      res[gropKey] = [cur]
    }
    return res
  }, {})
  // 按小板类型进行分类  柜体板、门板、背板
  const partTypeList = ['Plank', 'SingleDoor', 'BackPlank']
  const result = []
  for (const key in groupNoObj) {
    const parts = groupNoObj[key]
    /** 面积统计 */
    const areaObj = parts.reduce(
      (res, cur) => {
        const partType = String(cur.role)
        if (partTypeList.includes(partType)) {
          res[partType] += cur.realRect.width * cur.realRect.height
        } else {
          res['Plank'] += cur.realRect.width * cur.realRect.height
        }
        return res
      },
      { SingleDoor: 0, Plank: 0, BackPlank: 0 }
    )

    for (const key in areaObj) {
      areaObj[key] = toDecimal(areaObj[key] / 1000000, 2)
    }
    const gropKeyArr = key.split('@_@')
    result.push({
      type: gropKeyArr[1],
      id: gropKeyArr[0],
      data: areaObj,
    })
  }

  return result
}
